/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dcoViewer.vue?vue&type=template&id=6a0f330e&scoped=true&"
import script from "./dcoViewer.vue?vue&type=script&lang=js&"
export * from "./dcoViewer.vue?vue&type=script&lang=js&"
import style0 from "./dcoViewer.vue?vue&type=style&index=0&id=6a0f330e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f330e",
  null
  
)

export default component.exports